angular.module('iqxCore').factory('AvatarService', function () {
  function hashCode(str) {
    let hash = 0
    for (let i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash)
    }
    return hash
  }

  function intToRGB(i) {
    const c = (i & 0x00ffffff).toString(16).toUpperCase()
    return '#' + '00000'.substring(0, 6 - c.length) + c
  }

  return {
    generateAvatarSVG: function (name, size = 100) {
      const initials = name
        .split(' ')
        .map((word) => word[0].toUpperCase())
        .join('')
        .slice(0, 2)
      const bgColor = intToRGB(hashCode(name))

      return `data:image/svg+xml;base64,${btoa(`
                <svg width="${size}" height="${size}" xmlns="http://www.w3.org/2000/svg">
                    <rect width="100%" height="100%" fill="${bgColor}" rx="${size / 5}" />
                    <text x="50%" y="50%" font-family="Arial, sans-serif" font-size="${size / 2.5}" 
                          fill="#fff" text-anchor="middle" dominant-baseline="middle">
                        ${initials}
                    </text>
                </svg>
            `)}`
    }
  }
})
